<template>
  <div v-on-clickaway="closeSelector" class="relative">
    <button
      class="nav-action-item flex items-center gap-1 p-1 rounded-[5px] hover:bg-gray-100 transition-colors shrink-0 cursor-pointer outline-none border-0 bg-transparent"
      @click="toggleSelector"
    >
      <div class="flex items-center gap-[5px]">
        <span
          class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
        >
          person
        </span>
        <span class="text-sm text-gray-600 leading-5 whitespace-nowrap">
          {{
            assigneeName || $t('CONVERSATION.CARD_CONTEXT_MENU.ASSIGN_AGENT')
          }}
        </span>
      </div>
      <span
        class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
      >
        expand_more
      </span>
    </button>
    <dropdown-panel
      v-if="isOpenSelector"
      :items="allowedAgentList"
      :selected-items="selectedItems"
      selected-key="id"
      :searchable="searchable"
      :search.sync="search"
      :direction="'left-0'"
      :no-result-text="$t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.NO_RESULTS.AGENT')"
      :placeholder="$t('AGENT_MGMT.MULTI_SELECTOR.PLACEHOLDER')"
      @select="onSelectAgent"
    >
      <template v-if="showSelfAssign" #header>
        <div class="self-assign-btn" @click.prevent="onSelfAssign">
          <span class="material-symbols-outlined text-[24px] text-green-500">
            person
          </span>
          <span>{{ $t('CONVERSATION.ASSIGN_TO_ME') }}</span>
        </div>
        <hr
          class="border-gray-200 mx-[9px] my-0 sticky left-0 top-[40px] z-10"
        />
      </template>
      <template #item="{ item }">
        <span>{{ item.name }}</span>
      </template>
      <template v-if="assignedAgent" #footer>
        <hr
          class="border-gray-200 mx-[9px] my-0 sticky left-0 bottom-[40px] z-10"
        />
        <div class="unassigned-btn" @click="onUnassignAgent">
          <span class="material-symbols-outlined text-gray-500 text-[24px]">
            person_cancel
          </span>
          <span>{{ $t('CONVERSATION.UNASSIGN') }}</span>
        </div>
      </template>
    </dropdown-panel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import DropdownPanel from './DropdownPanel.vue';
import agentMixin from 'dashboard/mixins/agentMixin';

export default {
  components: { DropdownPanel },
  mixins: [clickaway, agentMixin],
  props: {
    searchable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpenSelector: false,
      search: '',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentChat: 'getSelectedChat',
    }),
    inboxId() {
      return this.currentChat?.inbox_id;
    },
    assigneeName() {
      return this.currentChat?.meta?.assignee?.name || '';
    },
    assignedAgent() {
      return this.currentChat?.meta?.assignee;
    },
    selectedItems() {
      return [this.assignedAgent?.id];
    },
    allowedAgentList() {
      return this.agentsList.filter(
        agent =>
          agent.see_all_conversations ||
          agent.assignable_to_inbox?.includes(this.inboxId)
      );
    },
    showSelfAssign() {
      if (!this.assignedAgent) {
        return true;
      }
      if (this.assignedAgent.id !== this.currentUser.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    toggleSelector() {
      this.isOpenSelector = !this.isOpenSelector;
    },
    closeSelector() {
      this.isOpenSelector = false;
    },
    onSelectAgent(option) {
      const agentId = option ? option.id : 0;
      this.$store.dispatch('setCurrentChatAssignee', option);
      this.$store
        .dispatch('assignAgent', {
          conversationId: this.currentChat.id,
          agentId,
        })
        .then(() => {
          this.showAlert(this.$t('CONVERSATION.CHANGE_AGENT'));
        })
        .catch(error => {
          this.showAlert(
            error?.response?.data?.error ||
              this.$t('CONVERSATION.CHANGE_AGENT_FAILED')
          );
        });
      this.closeSelector();
    },
    onSelfAssign() {
      const { avatar_url: thumbnail, ...rest } = this.currentUser;
      this.onSelectAgent({ ...rest, thumbnail });
    },
    onUnassignAgent() {
      const none = this.createNoneAgent;
      this.onSelectAgent(none);
    },
  },
};
</script>
<style lang="scss" scoped>
.unassigned-btn {
  @apply flex flex-row items-center gap-1 py-2 px-3 sticky left-0 bottom-0 z-10 text-base;
  @apply bg-white text-gray-600 hover:bg-[#F0FDF4] hover:text-[#1F845A] cursor-pointer;

  &:hover .material-symbols-outlined {
    @apply text-[#1F845A];
  }
}
.self-assign-btn {
  @apply flex flex-row items-center gap-1 py-2 px-3 sticky left-0 top-0 z-10 text-base;
  @apply bg-white text-green-500 hover:bg-[#F0FDF4] hover:text-[#1F845A] cursor-pointer;

  &:hover .material-symbols-outlined {
    @apply text-[#1F845A];
  }
}
</style>
